





















import { Component } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import RTab from "@/components/RTab.vue";
import ROrderInfo from "@/components/ROrderInfo.vue";
import CheckRestaurantLogin from "@/utils/CheckRestaurantLogin";
import OrderModule from "@/store/order";
import { OrdersApi } from "@/services/api-service";

@Component({
  components: {
    CHeader,
    CFooter,
    RTab,
    ROrderInfo,
  },
})
export default class ROrderDetail extends CheckRestaurantLogin {
  private mounted() {
    this.getOrder();
  }

  private async getOrder() {
    const { uuid } = this.$route.params;
    try {
      const orderRes = await OrdersApi.instance.getOrder(uuid);
      if (!orderRes.data.data?.order) {
        throw Error("Order not found");
      }
      OrderModule.commitOrder(orderRes.data.data.order);
    } catch (err) {
      console.log(err);
    }
  }
}
